import {
  subscribe,
  setFilters,
  clearFilters,
  getState
} from '../state/store.js';

const statusFilter = document.getElementById('statusFilter');
const classFilter = document.getElementById('classFilter');
const locationFilter = document.getElementById('locationFilter');
const playerFilter = document.getElementById('playerFilter');
const searchInput = document.getElementById('searchInput');
const clearBtn = document.getElementById('clearFiltersBtn');

const renderOptions = (select, values, placeholder, { defaultValue } = {}) => {
  const current = select.value || defaultValue || '';
  select.innerHTML =
    `<option value="">${placeholder}</option>` +
    values.map((v) => `<option value="${v}">${v}</option>`).join('');
  if (current && values.includes(current)) select.value = current;
  else if (defaultValue && values.includes(defaultValue)) select.value = defaultValue;
};

export const initFilters = () => {
  searchInput.addEventListener('input', (e) => {
    setFilters({ search: e.target.value });
  });

  statusFilter.addEventListener('change', (e) => setFilters({ status: e.target.value }));
  classFilter.addEventListener('change', (e) => setFilters({ class: e.target.value }));
  locationFilter.addEventListener('change', (e) => setFilters({ location: e.target.value }));
  playerFilter.addEventListener('change', (e) => setFilters({ player: e.target.value }));
  clearBtn.addEventListener('click', () => {
    clearFilters();
    searchInput.value = '';
    statusFilter.value = '';
    classFilter.value = '';
    locationFilter.value = '';
    playerFilter.value = '';
  });

  let memo = { statuses: '', classes: '', locations: '', players: '', viewMode: '' };

  subscribe(({ characters, viewMode }) => {
    if (viewMode !== memo.viewMode) {
      searchInput.placeholder = viewMode === 'dm' ? 'Character or player' : 'Character';
      memo.viewMode = viewMode;
    }
    const statuses = Array.from(
      new Set(
        characters
          .map((c) => String(c.status || '').trim())
          .filter((status) => status && status.toLowerCase() !== 'unknown')
      )
    ).sort();
    const classes = Array.from(
      new Set(
        characters.flatMap((character) =>
          String(character.class || '')
            .split(',')
            .map((value) => value.trim())
            .filter(Boolean)
        )
      )
    ).sort();
    const locations = Array.from(new Set(characters.map((c) => c.current_location).filter(Boolean))).sort();
    const players = Array.from(new Set(characters.map((c) => c.player).filter(Boolean))).sort();

    const statusKey = statuses.join('|');
    const classKey = classes.join('|');
    const locationKey = locations.join('|');
    const playerKey = players.join('|');

    if (statusKey !== memo.statuses) {
      renderOptions(statusFilter, statuses, 'Any status', { defaultValue: 'Alive' });
      memo.statuses = statusKey;
    }
    if (classKey !== memo.classes) {
      renderOptions(classFilter, classes, 'Any class');
      memo.classes = classKey;
    }
    if (locationKey !== memo.locations) {
      renderOptions(locationFilter, locations, 'Any location');
      memo.locations = locationKey;
    }
    if (playerKey !== memo.players) {
      renderOptions(playerFilter, players, 'Any player');
      memo.players = playerKey;
    }
  });

  // Initialize with current state values if any
  const { filters } = getState();
  searchInput.value = filters.search;
  if (!filters.status) {
    statusFilter.value = 'Alive';
    setFilters({ status: 'Alive' });
  } else {
    statusFilter.value = filters.status;
  }
};
